import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Profile } from '../../shared/configurations/profile.constant';
import {
    ListDataParameters,
    PageListData,
} from '../../shared/interfaces/list-data-params';
import { MediaMention } from '../../shared/interfaces/media-mention.interface';
import { JwtUtilService } from '../../core/jwt-util.service';
import { RestApiBase } from '../../shared/configurations/rest-api-base.config';
import { UrlUtils } from '../../shared/utils/url.utils';
import { ProfileService } from '../profile.service';

@Injectable({
    providedIn: 'root',
})
export class ProfileMentionsService {
    private http = inject(HttpClient);
    private jwtUtilService = inject(JwtUtilService);
    private profileService = inject(ProfileService);

    institutionCode: string;

    constructor() {
        this.institutionCode = UrlUtils.getParam('institution');
    }

    getListDataParameters(_offset?: number) {
        const defaultListDataParams: ListDataParameters = {
            pagination: { rows: Profile.BULK_SIZE, offset: _offset || 1 },
            sorts: [{ sortBy: 'start_date', sortDir: 'desc' }],
        };
        return defaultListDataParams;
    }

    getMediaMentions(offset: number) {
        let params = new HttpParams().set('institution', this.institutionCode);
        if (this.profileService.isPublicPage) {
            params = params.set('urlIdentifier', this.profileService.userID);
            return this.http.post<PageListData<MediaMention>>(
                RestApiBase.GET_RESEARCHER_MEDIA_MENTIONS_FOR_PUBLIC_PROFILE,
                this.getListDataParameters(offset),
                { params }
            );
        }
        params = params.set('userID', this.jwtUtilService.getUserID());
        return this.http.post<PageListData<MediaMention>>(
            RestApiBase.GET_RESEARCHER_MEDIA_MENTIONS,
            this.getListDataParameters(offset),
            { params }
        );
    }

    displayMentionOnPublicProfile(entityId: string) {
        const params = new HttpParams().set(
            'institution',
            this.institutionCode
        );
        return this.http.put(
            RestApiBase.DISPLAY_MENTION_ON_PUBLIC_PROFILE,
            {
                entityId,
                userID: this.jwtUtilService.getUserID(),
            },
            { params }
        );
    }

    hideMentionFromPublicProfile(entityId: string) {
        const params = new HttpParams().set(
            'institution',
            this.institutionCode
        );
        return this.http.put(
            RestApiBase.HIDE_MENTION_FROM_PUBLIC_PROFILE,
            {
                entityId,
                userID: this.jwtUtilService.getUserID(),
            },
            { params }
        );
    }

    displayMediaMentionsTab() {
        let params = new HttpParams().set('institution', this.institutionCode);
        params = params.set('userID', this.jwtUtilService.getUserID());
        return this.http.post(
            RestApiBase.DISPLAY_MENTIONS_TAB,
            this.getListDataParameters(),
            { params }
        );
    }

    displayMediaMentionsTabInPublicProfile(userID) {
        const params = new HttpParams()
            .set('institution', this.institutionCode)
            .set('isUserLoggedIn', String(this.jwtUtilService.isLoggedIn()))
            .set('urlIdentifier', userID);
        return this.http.post(
            RestApiBase.DISPLAY_MENTIONS_TAB_IN_PUBLIC_PROFILE,
            this.getListDataParameters(),
            { params }
        );
    }
}
